import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useEntityIdParam } from '../../hooks/useEntityIdParam';
import { useSMLDatePickerDateParam } from '../../hooks/useSMLDatePickerDateParam';
import { useCanViewListeningInsights } from '../../hooks/useCanViewListeningInsights';
import { useArtistListeningScoreChart } from '../../hooks/useArtistListeningScoreChart';
import { ListeningScoreChart } from '../ListeningScoreChart/ListeningScoreChart';

const ArtistListeningScoreChartComponent: React.FC = () => {
  const intl = useIntl();
  const artistId = useEntityIdParam('artist');
  const { selectedDate, rangeDays } = useSMLDatePickerDateParam();
  const canViewListeningInsights = useCanViewListeningInsights();

  const { data, isLoading, error } = useArtistListeningScoreChart({
    artistId: artistId || '',
    date: selectedDate,
    rangeDays,
    enabled: canViewListeningInsights,
  });

  const chartData = React.useMemo(() => data?.data ?? [], [data?.data]);

  return (
    <ListeningScoreChart
      title={intl.formatMessage({ id: 'app.sml.artist.details.listening-score', defaultMessage: 'Listening Score' })}
      data={chartData}
      isLoading={isLoading}
      error={error}
      emptyLabel={intl.formatMessage({
        id: 'app.sml.artist.details.listening-score.empty',
        defaultMessage: 'No listening data yet',
      })}
      errorLabel={intl.formatMessage({ id: 'app.sml.common.error', defaultMessage: 'Error' })}
    />
  );
};

export const ArtistListeningScoreChart = TypedMemo(ArtistListeningScoreChartComponent);
